import { render } from "./SignDoc.vue?vue&type=template&id=ab0c58f8&scoped=true"
import script from "./SignDoc.vue?vue&type=script&lang=js"
export * from "./SignDoc.vue?vue&type=script&lang=js"

import "./SignDoc.vue?vue&type=style&index=0&id=ab0c58f8&scoped=true&lang=css"

import exportComponent from "C:\\SeaFarer\\SeaFarer\\AMDTransportation_FE\\amd_transportation_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab0c58f8"]])

export default __exports__